var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'mui-button',
    'clickable',
    'flex',
    { primary: _vm.type === 'primary' },
    { yellow: _vm.type === 'yellow' },
    { green: _vm.type === 'green' },
    { grey: _vm.type === 'grey' },
    { large: _vm.size === 'large' },
    { disabled: _vm.disabled },
  ],on:{"click":_vm.handleClick}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "+_vm._s(_vm.loadingText)+" ")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[(!!_vm.icon)?_c('svg-icon',{staticClass:"icon-16 m-r-16",attrs:{"type":_vm.icon}}):_vm._e(),_vm._t("default"),(!!_vm.iconAfter)?_c('svg-icon',{staticClass:"icon-16 m-l-16",attrs:{"type":_vm.iconAfter}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }